import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5fe7890b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=scss"
import style1 from "./Footer.vue?vue&type=style&index=1&id=5fe7890b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe7890b",
  null
  
)

export default component.exports